import { Controller } from '@hotwired/stimulus';

export const getIdentifier = (filename) => {
    return filename
        .replace(/^.*[\\/]/, '') // Remove directory path
        .replace(/-controller\.js$/, '') // Remove '-controller.js' suffix
        .replace('_', '-');
}

export const registerLazyControllers = (application, context) => {
    context.keys().forEach((filename) => {
        const identifier = getIdentifier(filename);

        let modulePromise = null;

        const loadAndRegister = () => {
            if (modulePromise) return modulePromise;

            modulePromise = context(filename)
                .then((module) => {
                    application.register(identifier, module.default);
                })
                .catch((error) => {
                    modulePromise = null;
                    console.error(`[Stimulus] Failed to load controller "${identifier}":`, error);
                });

            return modulePromise;
        };

        application.register(identifier, class extends Controller {
            constructor(...args) {
                super(...args);

                // Stimulus may dispatch a window-scoped action against this
                // placeholder before `loadAndRegister` swaps in the real
                // controller. Turn any such call into a silent no-op instead
                // of Stimulus throwing "references undefined method".
                return new Proxy(this, {
                    get(target, prop, receiver) {
                        const value = Reflect.get(target, prop, receiver);

                        if (value !== undefined || prop in target || typeof prop === 'symbol') {
                            return value;
                        }

                        return () => {};
                    },
                });
            }

            connect() {
                loadAndRegister();
            }
        });
    });
};